// src/components/Common/MinimumChargeNotice/MinimumChargeNotice.jsx
import React from 'react';
import { FaCircleInfo } from 'react-icons/fa6';
import './MinimumChargeNotice.less';

/**
 * MinimumChargeNotice Component
 * Displays minimum charge information in a calm, informational style
 * Consistent with other pricing elements (Rate / kWh, Session Fee)
 * 
 * @param {string|number} amount - Formatted amount string (e.g., "$10.00") or number
 * @param {string} className - Optional additional CSS classes
 */
const MinimumChargeNotice = ({ amount, className = '' }) => {
  if (!amount || amount <= 0) {
    return null;
  }

  return (
    <div className={`minimum-charge-notice ${className}`}>
      <div className="mcn-icon">
        <FaCircleInfo size={16} />
      </div>
      <div className="mcn-content">
        <div className="mcn-label">Minimum charge</div>
        <div className="mcn-value">{amount}</div>
        <div className="mcn-helper">Applies per session</div>
      </div>
    </div>
  );
};

export default MinimumChargeNotice;
